import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export const passwordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = typeof control.value === 'string' ? control.value : '';
  const missingUppercase = !/[A-Z]/.test(value);
  const missingLowercase = !/[a-z]/.test(value);
  const missingNumber = !/\d/.test(value);
  const missingSpecial = !/[\W_]/.test(value);

  if (!missingUppercase && !missingLowercase && !missingNumber && !missingSpecial) {
    return null;
  }

  return {
    password: true,
    pattern: true,
    ...(missingUppercase ? {missingUppercase: true} : {}),
    ...(missingLowercase ? {missingLowercase: true} : {}),
    ...(missingNumber ? {missingNumber: true} : {}),
    ...(missingSpecial ? {missingSpecial: true} : {})
  };
};
